import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { cn } from '@/frontend/utils';
type TailwindProps = {
  size?: string | number;
  className?: string;
  alt?: string;
};
const SIZE_TO_PX: Record<string, number> = {
  '6': 24,
  '8': 32,
  '10': 40,
  '12': 48,
  '16': 64
};
export function Tailwind(t0) {
  const $ = _c(7);
  const {
    size: t1,
    className,
    alt: t2
  } = t0;
  const size = t1 === undefined ? "12" : t1;
  const alt = t2 === undefined ? "Tailwind" : t2;
  const sizeValue = typeof size === "number" ? size : String(size);
  const px = SIZE_TO_PX[sizeValue] ?? 48;
  const sizeClass = `size-${size}`;
  let t3;
  if ($[0] !== className || $[1] !== sizeClass) {
    t3 = cn(sizeClass, className);
    $[0] = className;
    $[1] = sizeClass;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== alt || $[4] !== px || $[5] !== t3) {
    t4 = <Image src="https://upload.wikimedia.org/wikipedia/commons/d/d5/Tailwind_CSS_Logo.svg" alt={alt} width={px} height={px} className={t3} />;
    $[3] = alt;
    $[4] = px;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}